// Import .less entry point
import '../assets/private/stylesheets/create-account/_create-account.less';
import './customer/styles/style';

// Import analytics
import { init as initAnalytics } from './analytics/routes/authentification.anly.route';
import { init as initAuthentificationLostPassword } from './customer/authentication/authentication-lost-password';
import { init as initAuthentificationResetPassword } from './customer/authentication/authentication-reset-password';
import { init as initCustomerPassword } from './customer/customer-password';

document.addEventListener('DOMContentLoaded', () => {
  if (cube.$id('lost-password')) initAuthentificationLostPassword();
  if (cube.$id('js-reset-password')) initAuthentificationResetPassword();
  if (cube.$('.js-password')) initCustomerPassword();

  if ( window.cube.config.anly_useLegacy === 'Y') {
    initAnalytics();
  }
});



// WEBPACK FOOTER //
// ./src/authentication.route.js